module.exports = __webpack_public_path__ + "img/tree-07-i-trunk.95ac9ba6.png";